import React from "react";

type SecondaryButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
  id?: string;
};

const SecondaryButton: React.FC<SecondaryButtonProps> = React.memo(
  ({
    children,
    onClick,
    type = "button",
    disabled = false,
    className = "",
    id,
  }) => {
    return (
      <button
        id={id}
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`
        px-4 py-2
        border border-black
        transition-colors
        disabled:opacity-60 disabled:cursor-not-allowed
        rounded
        font-semibold
        ${className}
      `}
      >
        {children}
      </button>
    );
  },
);

export default SecondaryButton;
